import React from "react";
import { Col, Row } from "reactstrap";
import { useSelector } from "react-redux";
import { URL } from "../../api";

const ElectricVehicleChargingSystems = ({ data }) => {
  const lang = useSelector((state) => state.lang.lang);

  const col1 = (item, index) => {
    return (
      <Col xs={12} sm={6} md={6} key={index} className="charging-system-item mb-3">
        <h1 className="f40 fw500">{item?.title[lang]}</h1>
        <p className="f20 fw500 color6">{item?.description[lang]}</p>
        <Row className="m-5 charce-img" >
          <a href="https://apps.apple.com/tr/app/%C3%A7elikler-enerji/id6746149357?l=tr" target="_blank" rel="noopener noreferrer">
            <img
              src={`${URL}${item?.files[0]}`}
              alt="App Store"
              className="charging-system-img mb-2"
              style={{ width: "148px", object: "cover", height: 50 }}
              loading="lazy"
            />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.raquun.celiklerenerji&pli=1" target="_blank" rel="noopener noreferrer">
            <img
              src={`${URL}${item?.files[1]}`}
              alt="Google Play"
              className="charging-system-img mb-2"
              style={{ width: "148px", object: "cover", height: 50 }}
              loading="lazy"
            />
          </a>
        </Row>
      </Col>
    )
  }

  const col2 = (item, index) => {
    return (
      <Col xs={12} sm={6} md={6} key={index} className="charging-system-item2 mb-4">
        <img src={`${URL}${lang === "tr" ? item?.files[0] : item?.files[1]}`} alt="Mobile" className="charging-img mb-3" loading="lazy" />
      </Col>
    )
  }

  return (
    <div className="electric-vehicle">
      <div className="d-flex justify-content-start align-items-center mb-4">
        <Row className="charging-systems ">
          {
            (data?.modules ? [...data.modules] : [])
              .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
              .map((item, index) => {
                if (item?.title?.tr === null || item?.title?.tr === undefined || item?.title?.tr === "") {
                  return col2(item, index);
                }
                else {
                  return col1(item, index);
                }
                return null;
              })
          }
        </Row>
      </div>
    </div>
  );
}

export default ElectricVehicleChargingSystems;
